module.exports = __webpack_public_path__ + "static/media/add-file.9fde79c3.svg";